import { render, staticRenderFns } from "./MemberNotesModal.vue?vue&type=template&id=76e98867&scoped=true&"
import script from "./MemberNotesModal.vue?vue&type=script&lang=js&"
export * from "./MemberNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberNotesModal.vue?vue&type=style&index=0&id=76e98867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e98867",
  null
  
)

export default component.exports